import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery/unstable_useMediaQuery';
import { PageTitle } from 'gatorcomponents';

import styles from './styles';


const FilterCard = ({
  title, children, classes, button, useMediaWidth, className, searchBar,
}) => {
  const isMobile = useMediaQuery(`(max-width:${useMediaWidth}px)`);

  const getPageTitleProps = () => {
    if (!button) {
      return {
        testId: 'filter-card-page-title',
        title,
        hideFilter: true,
      };
    }

    const buttonLabel = (button.props && button.props.children) || 'Button';

    const buttonTarget = (button.props && button.props.target);

    const headButton = {
      label: buttonLabel,
      buttonVariant: 'primary',
      buttonSize: 'medium2',
      fullWidthHead: true,
      onClick: () => {
        if (buttonTarget && buttonTarget !== '#') {
          window.location.href = buttonTarget;
        }
      },
    };

    return {
      testId: 'filter-card-page-title',
      title,
      headButton,
      hideFilter: true,
    };
  };

  return (
    <>
      {isMobile && (
        <>
          <div className={`${classes.newCard} ${className}`}>
            <PageTitle {...getPageTitleProps()} />
            <div className={`${classes.searchBarDiv}`}>
              {searchBar}
            </div>
          </div>
        </>
      )}
      <div>
        {children}
      </div>
    </>
  );
};

export default withStyles(styles)(FilterCard);
